import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { RolesSharedService } from '../services/roles-shared.service';
import * as _ from "lodash";
import { AuthenticationService } from '@app/shared/services/authentication.service';

@Component({
  selector: 'app-global-search-page',
  templateUrl: './global-search-page.component.html',
  styleUrls: ['./global-search-page.component.css']
})
export class GlobalSearchPageComponent implements OnInit {
globalSearchResponse : any;
searchFilter: any;
filterList = [
  {
    label: 'Research',
    typeKey: 'research_doc',
    checked: false
  },
  {
    label: 'Market Data',
    typeKey: 'market_data',
    checked: false
  },
  {
    label: 'Reports',
    typeKey: 'report',
    checked: false
  },
  {
    label: 'Analyst',
    typeKey: 'tech_analyst',
    checked: false
  }
];
userRole;

  constructor(    
    public rolesSharedService: RolesSharedService,
    private authenticationService: AuthenticationService,
    private router: Router
    ) { 
    this.rolesSharedService.searchResponse.subscribe(
      resp => {
        this.globalSearchResponse = resp;
      }
    );
    this.rolesSharedService.searchFilter.subscribe(
      resp => {
        this.searchFilter = resp;
        let typeString = this.searchFilter.type;
        typeString = typeString.replace(/["]+/g, '');
        let typeArray = typeString.split(',');
        _.forEach(this.filterList, (filterObj) => {
          if(typeArray.includes(filterObj.typeKey)) { 
            filterObj.checked = true;
            }
        });
      }
    );
  }

  ngOnInit() {
    this.getRole();
  }
  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }
  applyFilterOnMasterSearch(event, filterItem, index) {
    this.filterList[index].checked = !filterItem.checked;
    let selectedFilters = _.filter(this.filterList, {checked: true});
    let filterTypeString = ''; 
    selectedFilters.forEach(element => {
      if (filterTypeString === '') {
        filterTypeString = `"${element.typeKey}"`;
      } else {
        filterTypeString = `${filterTypeString},"${element.typeKey}"`;
      }
    });
    let filter = {
      search: this.searchFilter.search,
      type: filterTypeString,
      limit: 10,
      skip: 0
    }
    this.rolesSharedService.updateMasterSearchQueryFilters(filter);
    this.rolesSharedService.masterSearch(filter).subscribe((result) => {
      this.rolesSharedService.updateMasterSearchData(result);
      this.rolesSharedService.searchResponse.subscribe(
        resp => {
          this.globalSearchResponse = resp;
        }
      );
    });
  }
  onScrollDown() {
    let filterTypeString = ''; 
    let filter = {
      search: this.searchFilter.search,
      type: this.searchFilter.type,
      limit: 10,
      skip: this.searchFilter.skip + 10
    }
    this.rolesSharedService.updateMasterSearchQueryFilters(filter);
    this.rolesSharedService.masterSearch(filter).subscribe((result) => {
      this.rolesSharedService.updateMasterSearchData(result, this.globalSearchResponse);
      this.rolesSharedService.searchResponse.subscribe(
        resp => {
          this.globalSearchResponse = resp;
        }
      );
    });
  }
  onClickRedirect(obj) {
    switch (obj.type) {
      case "research_doc": {
        if (this.userRole === 'tech-vendor') {
          this.router.navigate([`${this.userRole}/market-data/${obj.id}`]);
        } else {
          this.router.navigate([`${this.userRole}/research-snapshot/${obj.id}`]);
        }
         break;
      } 
      case "report": {
        if(this.userRole === "tech-analyst") {
          this.router.navigate([`${this.userRole}/reports/report-details/${obj.id}`]);
        } else {
          this.router.navigate([`${this.userRole}/report-details/${obj.id}`]);
        }
         break;
      }
      case "tech_analyst": {
        this.router.navigate(['../../analyst-profile'] , { queryParams: { analystId: obj.id } });
        break;
     }
     case "market_data": {
      this.router.navigate(['/individual-market-data'], { queryParams: { marketDataId: obj.id } });
      break;
   }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/global-search-page/global-search-page.component.ts